export * from "./page-component-base";
